import React, { useEffect, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import DatePicker from '../../../General/DatePicker';
import isNull from '../../../../utils/NullChecking';
import { enumUtil } from '../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../utils/NotificationHandler';
import Loader from '../../../shared/Loader/Loader';
import { format } from 'date-fns';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import SearchList from '../../../Scheduler/Settings/SearchList';
import ModalFooter from '../../Shared/ModalFooter';
import { FindSecondChild } from '../../../../utils/FindMenuOption';
const FeeSetupProvider = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance')?.IsAdd
    let FeeSchedule_Modal = {
        ProviderFeeScheduleID: '',
        ProviderID: '',
        InsuranceID: '',
        Amount: '',
        StartDate: '',
        EndDate: '',
        RevenueCode: '',
        RevenueCodeID: ''
    }
    const { InsuranceID, mainInsuranceModal, onClose } = { ...props }
    const providersReducer = useSelector((state) => { return state?.GeneralDropDownsReducer });
    const API_URL = enumUtil.controller.ProviderFeeSchedule
    const API_URL_General = enumUtil.controller.General
    const [locationsDD, setLocationsDD] = useState([])
    const [selectedLocations, setSelectedLocations] = useState([])
    const [FeeScheduleData, setFeeScheduleData] = useState([])
    const [FeeScheduleSave, setFeeScheduleSave] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [selectedProvider, setselectedProvider] = useState('')
    const [selectedProviderID, setselectedProviderID] = useState('')
    const [is, setIs] = useState(false);
    const [billingEntityOption, setBillingEntityOption] = useState([])
    const [feeSetupId, setfeeSetupid] = useState('0')
    const LoadCountyDD = () => {
        ServerRequestProtected(API_URL + "/GetInsuranceCounty", 'post', {
            "TableName": enumUtil.enumAPITableName.AgencyProviderFeeSchedule,
        }).then((response) => {
            setLocationsDD(response)
        }).catch((error) => {
            setLocationsDD([])
        })
    }
    useEffect(() => {
        // LoadCountyDD()
        if (!isNull(InsuranceID)) {
            setIs(true)
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindPracticeFeeSetupSchedule ", 'post', {
                "TableName": enumUtil.enumAPITableName.PracticeFeeSetupSchedule,
                "ID": InsuranceID + ""
            }).then((response) => {
                let data = response
                if (response.length > 0) {
                    setselectedProvider(response[0].display)
                    setselectedProviderID(response[0].value)
                }
                setFeeScheduleData(response)
                let countylist = []
                data.map((item) => {
                    if (item.ProviderID === response[0].value) {
                        item.Locations && item.Locations.map((countyitem) => {
                            let coumtyitem = { value: countyitem.LocationID, display: countyitem.LocationName }
                            countylist.push(coumtyitem)
                        });
                    }
                });
                console.log(countylist);
                setLocationsDD(countylist)
                setIsLoading(false)
            }).catch((error) => {
                setFeeScheduleData([])
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
        ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.BillingEntity
        }).then((response) => {
            setBillingEntityOption(response)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }, [feeSetupId])
    const locationsList = providersReducer?.Location?.filter((item) => {
        return item?.value !== -1;
    });
    const handleCalendarChange = (date, name, index, countiesIndex, otherindex) => {
        var FormatedDate = date
        let updatedData = [...FeeScheduleData]
        let locationIndex
        updatedData[index].Locations.map((item, idx) => {
            if (item.LocationID === countiesIndex) {
                locationIndex = idx
            }
        })
        updatedData[index].Locations[locationIndex].OtherDetails[otherindex][name] = FormatedDate
        setFeeScheduleData(updatedData)
        // handleSaveChange(updatedData, index, countiesIndex, otherindex, name, FormatedDate);
    }

    const [RevCodeBody, setRevCodeBody] = useState({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": '' })
    const handleChangeOtherDetails = (e, index, countiesIndex, otherindex) => {
        setIs(false);
        let { name, value } = e.target
        let updatedData = [...FeeScheduleData]
        let locationIndex
        updatedData[index].Locations.map((item, idx) => {
            if (item.LocationID === countiesIndex) {
                locationIndex = idx
            }
        })
        if (name === 'BillingEntity' && value === '2') {
            updatedData[index].Locations[locationIndex].OtherDetails[otherindex]['DefaultUnits'] = ''

        }
        updatedData[index].Locations[locationIndex].OtherDetails[otherindex][name] = value
        setFeeScheduleData(updatedData)
        if (name === 'RevenueCode') {
            setRevCodeBody({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": value })
        }
        // handleSaveChange(updatedData, index, countiesIndex, otherindex, name, value);
    }
    const handleSaveChange = (updatedData, index, countiesIndex, otherindex, field, value) => {
        const updatedSaveData = [...FeeScheduleSave];
        const detail = updatedData[index].Locations[countiesIndex].OtherDetails[otherindex];
        const existingEntryIndex = updatedSaveData.findIndex(item => item.ProviderFeeScheduleID === detail.ProviderFeeScheduleID);

        const newEntry = {
            ProviderFeeScheduleID: detail.ProviderFeeScheduleID,
            LocationID: updatedData[index].LocationID,
            InsuranceID: InsuranceID,
            ProcedureCode: detail.ProcedureCode,
            Amount: detail.Amount,
            StartDate: detail.StartDate,
            EndDate: detail.EndDate,
        };

        if (existingEntryIndex !== -1) {
            // Update the existing entry
            updatedSaveData[existingEntryIndex] = { ...updatedSaveData[existingEntryIndex], [field]: value };
        } else {
            // Add new entry
            updatedSaveData.push(newEntry);
        }
        setFeeScheduleSave(updatedSaveData)
    }
    const handleSelectRevenueCode = (singlerow, name, type, index, countiesIndex, otherindex) => {
        setIs(true)
        let updatedData = [...FeeScheduleData]
        console.log(singlerow);
        if (!isNull(singlerow)) {
            updatedData[index].Locations[countiesIndex].OtherDetails[otherindex][name] = singlerow.code + ""
            updatedData[index].Locations[countiesIndex].OtherDetails[otherindex]['RevenueCodeID'] = singlerow.value + ""
        } else {
            updatedData[index].Locations[countiesIndex].OtherDetails[otherindex][name] = ""
            updatedData[index].Locations[countiesIndex].OtherDetails[otherindex]['RevenueCodeID'] = ""
        }
        setFeeScheduleData(updatedData)


    }
    const handelChangeLocationDD = (e) => {
        setIs(false);
        setselectedProvider(e.target.value)
    }
    const handleSelectLocation = (selectedData) => {
        if (!isNull(selectedData)) {
            setselectedProvider(selectedData.display)
            setselectedProviderID(selectedData.value)
            let countylist = []
            FeeScheduleData.map((item) => {
                if (item.ProviderID === selectedData.value) {
                    item.Locations && item.Locations.map((countyitem) => {
                        let coumtyitem = { value: countyitem.LocationID, display: countyitem.LocationName }
                        countylist.push(coumtyitem)
                    });
                }
            })
            setLocationsDD(countylist)
            setSelectedLocations([])
        }
    }
    const handleSelectedCounties = (selectedItems) => {
        setSelectedLocations(selectedItems)
    }
    const handleSaveFeeSetup = () => {
        let BillingEntityValidation = false
        let saveState = []
        FeeScheduleData.map((item) => {
            item.Locations && item.Locations.map((countyitem) => {
                countyitem.OtherDetails && countyitem.OtherDetails.map((detailsitem) => {
                    if (!isNull(detailsitem.Amount) && isNull(detailsitem.BillingEntity)) {
                        BillingEntityValidation = true
                    }
                    console.log(detailsitem);

                    let saveDetailsitem = {
                        ProviderFeeScheduleID: !isNull(detailsitem.ProviderFeeScheduleID) ? detailsitem.ProviderFeeScheduleID : '0',
                        ProviderID: detailsitem.ProviderID,
                        InsuranceID: InsuranceID,
                        ProcedureCode: detailsitem.ProcedureCode,
                        ProcedureCodeID: detailsitem.ProcedureCodeID,
                        Amount: detailsitem.Amount === "" ? '-99' : detailsitem.Amount,
                        AllowedAmount: detailsitem.AllowedAmount === "" ? '-99' : detailsitem.AllowedAmount,
                        StartDate: detailsitem.StartDate,
                        EndDate: detailsitem.EndDate,
                        // FeeSetupCountyID: detailsitem.FeeSetupCountyID,
                        RevenueCode: detailsitem.RevenueCode,
                        RevenueCodeID: detailsitem.RevenueCodeID,
                        BillingEntity: detailsitem.BillingEntity,
                        DefaultUnits: detailsitem.DefaultUnits === "" ? '-99' : detailsitem.DefaultUnits,
                        LocationID: detailsitem.locationid,
                    };
                    saveState.push(saveDetailsitem)
                });

            });
        });
        // if (!BillingEntityValidation) {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/SavePracticeFeeSetupSchedule  ", 'post', {
            "TableName": enumUtil.enumAPITableName.PracticeFeeSetupSchedule,
            "Data": saveState
        }).then((response) => {
            setIsLoading(false)
            setfeeSetupid((Math.random()))
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
        }).catch((error) => {
            setIsLoading(false)
        })
        // } else {
        //     NotificationHandler('Billing Entity is required where amount is greater than zero!', enumUtil.enumtoaster.error)
        // }

    }

    console.log('FeeScheduleData', FeeScheduleData);

    return (
        <>
            {isLoading ? <Loader /> : null}
            <div className='row m-0 mt-3 ar-fee_setup'>

                <div className="col-md-4 pe-0">
                    <div className="pb-2">
                        <p className="ar-light-color text text-nowrap validation_message">Insurance: <span className="heading fs-14 ar-dark-color" title={mainInsuranceModal.InsuranceName}>{mainInsuranceModal.InsuranceName}</span></p>
                    </div>
                    <div className="pb-1">
                        <div className='input form-group'>
                            <label htmlFor="ProviderID">Provider</label>
                            <SuperSearchList
                                type="client"
                                id='ProviderID'
                                name='ProviderID'
                                searchValue={selectedProvider}
                                data={FeeScheduleData}
                                onChange={handelChangeLocationDD}
                                getSelectedData={handleSelectLocation}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                    </div>
                    <div className="input form-group">
                        <label htmlFor="Locations" className="d-flex align-items-center text-nowrap">Select Locations for {' '}<span className="font-m text-nowrap validation_message ms-1" title={selectedProvider}> {selectedProvider}</span>: <span className="ar_count ms-1 position-static px-1 text-white w-fit-content"> {selectedLocations.length} of {locationsDD.length}</span></label>
                        <SearchList
                            ItemLists={locationsDD}
                            type={"FeeSetup"}
                            Name={'Provider'}
                            // getProvider={props.getProvider}
                            handleSelectedProviders={handleSelectedCounties}
                        // view={view}
                        />
                    </div>
                    <p className="text red-text mt-1 fst-italic fs-10">Please select Locations to update the rate</p>

                </div>
                {FeeScheduleData.length > 0 ?
                    <div className="col-md-8 pe-0">
                        <div className=" d-flex justify-content-between align-items-center select-bg-img-1 pb-1">
                            <p className="provider-header px-2 ar-dark-color heading w-fit-content">Provider: {selectedProvider}</p>
                            <div className="input">
                                <select className="form-control fc-xs rounded-5" id="BillingDocumentType" name="BillingDocumentType">
                                    <option>
                                        Show Recent
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div className="app-accordian">
                            {FeeScheduleData && FeeScheduleData.map((item, index) => {
                                if (selectedProviderID === item.ProviderID)
                                    return (
                                        item.Locations && item.Locations.filter(countiesItem =>
                                            selectedLocations.some(selected => selected.value === countiesItem.LocationID))
                                            .map((countiesItem, countiesIndex) => (
                                                <Accordion key={`accordion-${countiesIndex}`} defaultExpanded={true}>
                                                    <AccordionSummary
                                                        aria-hidden='true'
                                                        id={`prac1-header-${countiesIndex}`}
                                                        aria-controls={`prac1-content-${countiesIndex}`}
                                                        expandIcon={<ExpandMoreIcon />}
                                                        className="px-2"
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <p className="heading d-flex align-items-center gap-1">
                                                                <i className="icon-location-v1">
                                                                    <i className="path1"></i>
                                                                    <i className="path2"></i>
                                                                    <i className="path3"></i>
                                                                </i>
                                                                {countiesItem.LocationName}
                                                            </p>
                                                            <i className="icon-close fs-10"></i>
                                                            {/* <i className="fs-10 icon-edit-pencil"></i> */}
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className="p-0">
                                                        <div className='fee-setup-table ad-expand-table'>
                                                            <table className='w-100'>
                                                                <thead>
                                                                    <tr>
                                                                        <th className='heading'>Code</th>
                                                                        {mainInsuranceModal?.PrimaryClaimType === "837 P" ? null : <th className='heading text-nowrap'> Rev. Code</th>}
                                                                        <th className='heading'>Amount</th>
                                                                        <th className='heading'>Allowed</th>

                                                                        <th className='heading'>Def. Units</th>
                                                                        <th >
                                                                            <div className='d-flex justify-content-around align-items-center'>
                                                                                <p className='heading'>Start Date</p>
                                                                                <p className='heading'>End Date</p>
                                                                            </div>
                                                                        </th>
                                                                        <th className='heading'></th>
                                                                        {/* <th className='heading'>End Date</th> */}

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {countiesItem.OtherDetails && countiesItem.OtherDetails.map((otherItem, otherindex) => (
                                                                        <tr>
                                                                            <td className='text'>
                                                                                {otherItem.ProcedureCode}
                                                                            </td>
                                                                            {mainInsuranceModal?.PrimaryClaimType === "837 P" ? null :
                                                                                <td>
                                                                                    <SuperSearchList
                                                                                        width={'80px'}
                                                                                        type='server'
                                                                                        id='RevenueCode'
                                                                                        name='RevenueCode'
                                                                                        searchValue={otherItem.RevenueCode}
                                                                                        ApiLink={API_URL_General + "/InstantSearch"}
                                                                                        method='post'
                                                                                        postBody={RevCodeBody}
                                                                                        onChange={(e) => handleChangeOtherDetails(e, index, otherItem.locationid, otherindex)}
                                                                                        getSelectedData={(singlerow, name, type) => handleSelectRevenueCode(singlerow, name, type, index, countiesIndex, otherindex)}
                                                                                        is={is}
                                                                                        sup_btn='sup_btn-Inp'
                                                                                        sup_inp='superSearchVisitInp'
                                                                                        disabled={true}
                                                                                        placeholder={"Search..."}
                                                                                    />
                                                                                </td>
                                                                            }
                                                                            <td>
                                                                                <div className="input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className='form-control amount'
                                                                                        id="Amount"
                                                                                        name='Amount'
                                                                                        value={otherItem.Amount}
                                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                        onChange={(e) => handleChangeOtherDetails(e, index, otherItem.locationid, otherindex)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className='form-control amount'
                                                                                        id="AllowedAmount"
                                                                                        name='AllowedAmount'
                                                                                        value={otherItem.AllowedAmount}
                                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                        onChange={(e) => handleChangeOtherDetails(e, index, otherItem.locationid, otherindex)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            {/* <td>
                                                                                <div className='input'>
                                                                                    <select
                                                                                        className='form-control'
                                                                                        name="BillingEntity"
                                                                                        id="BillingEntity"
                                                                                        value={otherItem.BillingEntity}
                                                                                        onChange={(e) => handleChangeOtherDetails(e, index, otherItem.locationid, otherindex)}
                                                                                    >
                                                                                        {billingEntityOption?.map((e, index) => (
                                                                                            <option value={e.value} key={index}>
                                                                                                {e.display}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                </div>
                                                                            </td> */}
                                                                            <td>
                                                                                <div className="input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className='form-control'
                                                                                        id="DefaultUnits"
                                                                                        name='DefaultUnits'
                                                                                        value={otherItem.DefaultUnits}
                                                                                        onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                                                                                        onChange={(e) => handleChangeOtherDetails(e, index, otherItem.locationid, otherindex)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td className='text'>
                                                                                <div className='d-flex align-items-center gap-2'>
                                                                                    <DatePicker
                                                                                        value={otherItem.StartDate}
                                                                                        handleCalendarChangefunc={date => handleCalendarChange(date, 'StartDate', index, otherItem.locationid, otherindex)}
                                                                                    />
                                                                                    <DatePicker
                                                                                        value={otherItem.EndDate}
                                                                                        handleCalendarChangefunc={date => handleCalendarChange(date, 'EndDate', index, otherItem.locationid, otherindex)}
                                                                                    />
                                                                                </div>

                                                                            </td>
                                                                            <td className=''><i className='icon-plus-feesetup fs-15'></i></td>
                                                                            {/* <td className='text'>
                                                                                <DatePicker
                                                                                    value={otherItem.EndDate}
                                                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'EndDate', index, countiesIndex, otherindex)}
                                                                                />
                                                                            </td> */}
                                                                            {/* <td className='text ar-toggle'>
                                                                                            <div className="form-check form-switch radio_button ms-0">
                                                                                                <input
                                                                                                    className="form-check-input position-absolute"
                                                                                                    type="checkbox"
                                                                                                    id="filesView"
                                                                                                    name="filesView"
                                                                                                    autoComplete="on"
                                                                                                />
                                                                                            </div>
                                                                                        </td> */}
                                                                        </tr>
                                                                    ))}

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))
                                    )
                            }
                            )}

                        </div>
                    </div>

                    : null
                }
            </div>
            <div className='free_footer'>
                <ModalFooter isSaved={onClose} handleSave={handleSaveFeeSetup} UpdatedDate={mainInsuranceModal.UpdatedDate} UpdatedBy={mainInsuranceModal.UpdatedBy} ID={''} IsEditAllowed={IsEditAllowed} />
            </div>

        </>

    )
}

export default FeeSetupProvider